//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation  } from "react-router-dom";

//css
import styled from "styled-components"

// page
import MyOrderDetail from "./components/MyOrderDetail"


export default function MyOrderDetailPage() {
  
    return (
            <MyOrderDetail/>
    );
  }

